import React from 'react';
import {Button, ButtonProps} from '@mui/material';
import styled from 'styled-components';

type ActionButtonProps = ButtonProps;

const StyledCancelButton = styled(Button)``;

const StyledActionButton = styled(Button)``;

export const CancelButton = ({disabled = false, type = 'button', ...rest}: ActionButtonProps) => {
    return (
        <StyledCancelButton
            disabled={disabled}
            type={type}
            {...rest}
        />
    );
};

export const ActionButton =
    ({variant = 'contained', color = 'primary', disabled = false, type = 'button', ...rest}: ActionButtonProps) => {

    return (
        <StyledActionButton
            variant={variant}
            color={color}
            disabled={disabled}
            type={type}
            {...rest}
        />
    );
};
